import React, { memo } from 'react'
import { useCalculateButtonStyles } from 'src/editor/shared/hooks/use-calculate-button-styles'
import { useSelectedButtonColor } from 'src/editor/shared/hooks/use-theme-color/use-selected-button-color'
import { Button as CommonButton } from 'src/shared/components/button/button'
import { CommonButtonEntityInterface } from 'src/shared/schemas/buttons/common-button-entity.schema'

interface BaseEditorButtonProps {
  entity: Omit<CommonButtonEntityInterface, 'type' | 'parentId'>
}

// TODO: reuse it in other button components
export const BaseEditorButton = memo(({ entity }: BaseEditorButtonProps) => {
  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
    calculatedTextColor,
    calculatedBackground,
    calculatedHover,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
    textColor: entity.textColor,
    mobileTextColor: entity.mobileTextColor,
    background: entity.background,
    mobileBackground: entity.mobileBackground,
    backgroundColor: entity.backgroundColor,
    mobileBackgroundColor: entity.mobileBackgroundColor,
    hover: entity.hover,
    mobileHover: entity.mobileHover,
  })

  return (
    <CommonButton
      iconClassNameBefore={entity.iconClassNameBefore}
      iconClassNameAfter={entity.iconClassNameAfter}
      text={entity.text}
      border={calculatedBorder.desktop}
      mobileBorder={calculatedBorder.mobile}
      subText={entity.subText}
      padding={calculatedPadding.desktop}
      mobilePadding={calculatedPadding.mobile}
      alignSelf={entity.alignSelf}
      mobileAlignSelf={entity.mobileAlignSelf}
      background={calculatedBackground.desktop}
      mobileBackground={calculatedBackground.mobile}
      attrId={entity.htmlAttrId}
      width={entity.width}
      mobileWidth={entity.mobileWidth}
      textColor={calculatedTextColor.desktop}
      mobileTextColor={calculatedTextColor.mobile}
      mobileSubTextColor={entity.mobileSubTextColor}
      subTextColor={entity.subTextColor}
      textFontSize={calculatedFontSize.desktop}
      mobileTextFontSize={calculatedFontSize.mobile}
      subTextFontSize={entity.subTextFontSize}
      mobileSubTextFontSize={entity.mobileSubTextFontSize}
      textFontFamily={calculatedFontFamily.desktop}
      textFontWeight={calculatedFontWeight.desktop}
      textFontStyle={calculatedFontStyle.desktop}
      lineHeight={calculatedLineHeight.desktop}
      subTextFontFamily={entity.subTextFontFamily}
      subTextFontWeight={entity.subTextFontWeight}
      subTextFontStyle={entity.subTextFontStyle}
      mobileTextFontFamily={calculatedFontFamily.mobile}
      mobileTextFontWeight={calculatedFontWeight.mobile}
      mobileTextFontStyle={calculatedFontStyle.mobile}
      mobileLineHeight={calculatedLineHeight.mobile}
      mobileSubTextFontFamily={entity.mobileSubTextFontFamily}
      mobileSubTextFontWeight={entity.mobileSubTextFontWeight}
      mobileSubTextFontStyle={entity.mobileSubTextFontStyle}
      boxShadow={entity.boxShadow}
      mobileBoxShadow={entity.mobileBoxShadow}
      hover={calculatedHover.desktop}
      mobileHover={calculatedHover.mobile}
    />
  )
})
